import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApproveModal from "../../../components/modals/approveModal";
import { customerApproveReject } from "../../../redux/actions/customerActions";
import "../../products/productDetail.css";

const SubscribeTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();
  const [approveShow, setApproveShow] = useState(false);
  const dispatch = useDispatch();

  const approvFunc = () => {
    dispatch(
      customerApproveReject(
        { status: "approved", vendor_subscribe_id: data?.id },
        onSuccess,
        onError
      )
    );
  };

  const onSuccess = (data) => {
    setApproveShow(false);
  };
  const onError = (err) => {
    console.log(err);
    setApproveShow(false);
  };

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">
        {data?.doctor_id ? data?.doctor?.code : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.pharmacy_id ? data?.pharmacy?.code : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.doctor_id ? `DR. ${data?.doctor?.name.toUpperCase()}` : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.pharmacy?.pharmacy_name
          ? data?.pharmacy?.pharmacy_name.toUpperCase()
          : "--"}
      </td>
      <td className="table-each-row-data">
        {(data?.doctor_id ? data?.doctor?.city?.name : "--") ||
          (data?.pharmacy_id ? data?.pharmacy?.city?.name : "--")}
      </td>
      <td className="table-each-row-data">
        {data?.doctor?.pharmacy_type
          ? data?.doctor?.pharmacy_type.charAt(0).toUpperCase() +
            data?.doctor?.pharmacy_type.slice(1)
          : "--"}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/customers/subscribe-request/view/${data?.id}`)
            }
          >
            {"view"}
          </button>
        </div>
      </td>
      <ApproveModal
        approvFunc={approvFunc}
        show={approveShow}
        handleClose={() => setApproveShow(false)}
        title={`customer -${
          data?.doctor_id ? data?.doctor?.code : data?.pharmacy?.code
        } ?`}
      />
    </tr>
  );
};

export default SubscribeTableData;
